import { formatMoney } from '@/lib/format'
import type { BillingInterval, FeatureKey, LimitKey, Plan } from '@/types/api'

export const PLAN_LIMIT_ORDER: LimitKey[] = ['displays', 'locations', 'players', 'users', 'storage_bytes', 'upload_bytes', 'analytics_retention_days']

export const FEATURE_ORDER: FeatureKey[] = [
  'channels',
  'campaigns',
  'advanced_scheduling',
  'proof_of_play',
  'screenshots',
  'data_sources',
  'emergency_broadcasts',
  'custom_roles',
  'approval_workflow',
  'flows',
  'custom_branding',
  'api_access',
]

/** Price per month for display; yearly plans are shown as their monthly equivalent. */
export function monthlyEquivalentCents(plan: Plan, interval: BillingInterval): number {
  return interval === 'yearly' ? Math.round(plan.price_yearly_cents / 12) : plan.price_monthly_cents
}

export function planPriceLabel(plan: Plan, interval: BillingInterval): string {
  const cents = monthlyEquivalentCents(plan, interval)
  return cents === 0 ? 'Free' : formatMoney(cents, plan.currency)
}

/** Yearly savings as a whole percent (0 when not cheaper). */
export function yearlySavingsPercent(plans: Plan[]): number {
  let best = 0
  for (const plan of plans) {
    const full = plan.price_monthly_cents * 12
    if (full <= 0 || plan.price_yearly_cents <= 0) continue
    best = Math.max(best, Math.round((1 - plan.price_yearly_cents / full) * 100))
  }
  return best
}
